import { Component, OnInit, Input } from '@angular/core';
import { Notification, Language } from '@ridango/core';

@Component( {
    selector: 'ridango-basic-notification-element',
    templateUrl: './basic-notification-element.component.html',
    styleUrls: [ './basic-notification-element.component.scss' ]
} )
export class BasicNotificationElementComponent implements OnInit {
    @Input() notification: Notification;
    @Input() lang;

    title = '';
    message = '';
    constructor() {
    }
    ngOnInit () {
        // tslint:disable-next-line:max-line-length


    }

}
